import styled from "styled-components";

export const Container = styled.div<{isOpen?: boolean}>`
  width: 720px;
  height: 100vh;
  color: white;
  background-color: #0c0d15;
  transition: width 0.3s ease;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  z-index: 100;
  position: absolute;
  left: 80px;
  border-right: 1px solid #4e5574;
  display: flex;
  flex-direction: column;

  transition: all 0.3s ease-in-out;

  &::-webkit-scrollbar {
    width: 15px;
    transition: width 0.3s ease;
  }

  &::-webkit-scrollbar-track {
    background: #1d2133;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #4e5574;
    border-radius: 10px;
    border: 3px solid #1d2133;
    transition: border-width 0.3s ease;
  }

  &::-webkit-scrollbar:hover {
    width: 16px;
  }

  &::-webkit-scrollbar-thumb:hover {
    border-width: 2px;
  }

  /* Scrollbar styles for Firefox */
  scrollbar-color: #4e5574 #1d2133;
  scrollbar-width: thin;

  /* &::-webkit-scrollbar: {
    scrollbar-width: auto;
  } */
`;

export const BtnBack = styled.div`
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

export const SideBarInfoTabsItem = styled.div<{isActive: boolean}>`
  display: flex;
  padding: 5px 10px;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  color: ${({isActive}) => (isActive ? "#fff" : "rgba(255, 255, 255, 0.4)")};
  font-size: 10px;
  background-color: #22272b;
  border: 1px solid;
  border-color: ${(props) =>
    props.isActive ? "#737DA8" : "rgba(115, 125, 168, 0.4)"};
  border-radius: 8px;

  cursor: ${(props) => (props.isActive ? "default" : "pointer")};
  opacity: ${(props) => (props.isActive ? 1 : 0.7)};

  &:hover {
    opacity: ${(props) => (props.isActive ? null : 0.9)};
  }
`;

export const TabTitle = styled.div`
  color: #11a0da;
  font-size: 18px;
  font-weight: 400;
`;

export const TabBlockAside = styled.div`
  background-color: #22272b;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 15px 20px;
  margin-bottom: 30px;
  border-radius: 10px;
`;

export const TabP = styled.div`
  color: white;
  font-size: 14px;
  line-height: 1.2;
  margin: 15px 0;

  a {
    color: #5bb5ff;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      color: #00f0ff;
    }
  }
`;

export const TabTitleDark = styled.div<{isSmall?: boolean}>`
  color: rgba(255, 255, 255, 0.6);
  font-size: ${(props) => (props.isSmall ? "14px" : "20px")};
  line-height: 1.2;
`;

export const TableGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid #4e5574;
  border-radius: 10px;
  font-size: 10px;

  .grid-header {
    display: contents;
    font-weight: bold;
    border-radius: 10px 10px 0 0;
    font-size: 12px;
    text-align: сenter;
  }
  .grid-header > div:first-child {
    border-radius: 10px 0 0 0;
  }
  .grid-header > div:last-child {
    border-radius: 0 10px 0 0;
  }

  .grid-row {
    display: contents;
  }

  .grid-header > div,
  .grid-row > div {
    padding: 10px;
    border: 1px solid #4e5574;
  }

  .grid-row:last-child {
    border-radius: 0 0 10px 10px;
  }

  .grid-row:last-child {
    border-radius: 0 0 10px 10px;
  }
  .grid-row:last-child > div:first-child {
    border-radius: 0 0 0 10px;
  }
  .grid-row:last-child > div:last-child {
    border-radius: 0 0 10px 0;
  }
`;
